import { Box, Option, Select, Typography } from '@mui/joy';
import { SCHEDULE_SORT_OPTIONS } from '../employeeOrdering';

export default function ScheduleSortSelect({ value, onChange, weekLabel }) {
    return <Box sx={{ minWidth: 0, width: { xs: '100%', sm: 235 }, maxWidth: '100%' }}>
        <Typography level="body-xs" sx={{ mb: 0.5, color: 'var(--joy-palette-text-tertiary)' }}>Порядок сотрудников · админы сверху</Typography>
        <Select size="sm" value={value} onChange={(_, next) => { if (next) onChange(next); }}
            aria-label={`Порядок сотрудников: ${weekLabel}`}
            sx={{ width: '100%', minWidth: 0, fontSize: 12, color: 'var(--joy-palette-text-primary)',
                bgcolor: 'var(--joy-palette-background-level2)', borderColor: 'var(--joy-palette-divider)',
                '&:hover': { bgcolor: 'var(--joy-palette-background-level3)' } }}
            slotProps={{ listbox: { sx: {
                bgcolor: 'var(--joy-palette-background-level2)', color: 'var(--joy-palette-text-primary)',
                border: '1px solid var(--joy-palette-divider)', boxShadow: '0 8px 32px rgba(0,0,0,0.5)',
                '& .MuiOption-root': { fontSize: 12, color: 'var(--joy-palette-text-primary)',
                    '&:hover, &[aria-selected="true"]': { bgcolor: 'rgba(162,38,226,0.18)', color: 'var(--joy-palette-text-primary)' } },
            } } }}>
            {SCHEDULE_SORT_OPTIONS.map(option => <Option key={option.value} value={option.value}>{option.label}</Option>)}
        </Select>
    </Box>;
}
